/**
 * @param {String} dflt Default value
 * @param {String} val Value is question
 * @return {String} The second value if it is not `null`, `undefined` or `empty`,
 * otherwise the default value.
 */
const defaultTo = dflt => val => ((val == null || val === '') ? dflt : val);

const trim = s => (s ? s.trim() : s);

/**
 * @param {*} fields Object info
 * @param {Array} concat An array of object properties whose values to be concated
 * @param {Array} pick An array of object properties to be checked.
 * The value of first existing one will be picked.
 * @param {String} fallback The name of object property to be returned
 * if `concat` or `pick` results in empty value.
 */
const getIdentifier = ({concat, pick, fallback = 'id'}) => (fields) => {
    let res;
    if (pick) { // pick first existing property
        const firstPick = pick.find(p => fields[p]);
        res = trim(fields[firstPick]);
    } else if (concat) { // concat props into value
        const concatValues = concat.map(c => trim(fields[c]));
        res = trim(concatValues.join(' '));
    }
    // fallback to some identifying property
    return defaultTo(trim(fields[fallback]))(res);
};

export default getIdentifier;
